module.exports = __webpack_public_path__ + "static/media/YF49_3.7fc6086e.jpg";